/**
 * Formatação de motivo/procedimento de consultas (plantão vs agendada).
 */

const ON_DEMAND_PREFIX_RE = /^\s*\[?\s*on[-\s]?demand\s*\]?\s*[-–—:]?\s*/i;
const PLANTÃO_PREFIX_RE = /^\s*\[?\s*via\s+plant[aã]o\s*\]?\s*[-–—:]?\s*/i;

/** True se o motivo indica consulta de plantão (legado [ON-DEMAND] ou via plantão). */
export function isOnDemandAppointmentReason(reason?: string | null): boolean {
  if (!reason) return false;
  const normalized = reason.toLowerCase();
  return (
    normalized.includes('on-demand') ||
    normalized.includes('on demand') ||
    normalized.includes('plantão') ||
    normalized.includes('plantao')
  );
}

/**
 * Exibe o motivo em português.
 * Ex.: "[ON-DEMAND] Dor de cabeça" → "via plantão — Dor de cabeça"
 */
export function formatAppointmentReasonForDisplay(
  reason?: string | null,
  fallback = 'Consulta',
): string {
  const raw = reason?.trim();
  if (!raw) return fallback;

  if (ON_DEMAND_PREFIX_RE.test(raw)) {
    const rest = raw.replace(ON_DEMAND_PREFIX_RE, '').trim();
    return rest ? `via plantão — ${rest}` : 'via plantão';
  }

  if (PLANTÃO_PREFIX_RE.test(raw) && !raw.toLowerCase().startsWith('via plantão')) {
    const rest = raw.replace(PLANTÃO_PREFIX_RE, '').trim();
    return rest ? `via plantão — ${rest}` : 'via plantão';
  }

  return raw;
}

/** Prefixo persistido em novas consultas de plantão. */
export const ON_DEMAND_REASON_PREFIX = 'via plantão —';

export function buildOnDemandAppointmentReason(patientReason: string): string {
  const cleaned = patientReason.trim();
  return cleaned ? `${ON_DEMAND_REASON_PREFIX}${cleaned}` : 'via plantão';
}
